import { Injectable } from '@angular/core';
import {
  DeleteUserPreferenceRequest,
  ListUserPreferencesRequest,
  UserPreference
} from '@ot/shared/model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EncoderService } from '../encoder';
import { UserPreferencesAPIService } from './user-preferences.api.service';

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {
  readonly context = 'taxManager';

  constructor(
    private apiService: UserPreferencesAPIService,
    private encoder: EncoderService
  ) {}

  updateUserPreference<T>(
    data: T,
    subcontext: string,
    identifier: string = ''
  ): Observable<T> {
    const request: UserPreference = {
      context: this.context,
      subcontext,
      identifier,
      data: this.encoder.encode<T>(data)
    };
    return this.apiService
      .updateUserPreference(request)
      .pipe(map(response => this.encoder.decode<T>(response.data)));
  }

  deleteUserPreference(
    subcontext: string,
    identifier: string = ''
  ): Observable<{}> {
    const request: DeleteUserPreferenceRequest = {
      context: this.context,
      subcontext,
      identifier
    };
    return this.apiService.deleteUserPreference(request);
  }

  listUserPreferences(
    subcontext: string,
    identifier: string = ''
  ): Observable<UserPreference[]> {
    const request: ListUserPreferencesRequest = {
      filter: {
        context: this.context,
        subcontext,
        identifier
      }
    };
    return this.apiService.listUserPreferences(request);
  }

  getUserPreference<T>(
    subcontext: string,
    identifier: string = ''
  ): Observable<T> {
    return this.listUserPreferences(subcontext, identifier).pipe(
      map(response => {
        const preference: UserPreference = response.find(
          userPreference => userPreference.identifier === identifier
        );
        if (!preference || !preference.data) {
          return null;
        }
        return this.encoder.decode<T>(preference.data);
      })
    );
  }
}
